import ComparisonParams from './ComparisonParams';

export default ComparisonParams;
